import { APP_USER_DETAIL_ROUTE } from "config/route-consts";
import React, { useEffect, useRef } from "react";
import authenticationService from "services/common-services/authentication-service";
import "./DropdownMenu.scss";
import { useDropdownMenuHook } from "./DropdownMenuHook";
import { translate } from "i18n/i18n";
export interface DropdownMenuProps {
  setIsShowAccountDropdown?: React.Dispatch<React.SetStateAction<boolean>>;
}
function DropdownMenu(props: DropdownMenuProps) {
  const { handleGetSwitchAccountCode } = useDropdownMenuHook();
  const { setIsShowAccountDropdown } = props;
  const user = JSON.parse(localStorage.getItem("currentUserInfo"));

  const handleClickToProfile = React.useCallback(() => {
    window.location.href = `${APP_USER_DETAIL_ROUTE}?id=${user?.id}`;
  }, [user?.id]);
  // const handleClickToChangePassword = React.useCallback(() => {
  //   window.location.href = `${APP_USER_MASTER_ROUTE}?idChangePassword=${user?.id}`;
  // }, [user?.id]);

  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event: { target: any }) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsShowAccountDropdown(false);
      }
    };
    document.addEventListener("click", handleClickOutside, true);

    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [setIsShowAccountDropdown]);

  const handleLogout = React.useCallback(() => {
    authenticationService.logout();
  }, []);

  return (
    <div className="dropdown__wrapper" ref={dropdownRef}>
      <div className="dropdown__container">
        <div className="dropdown__list-item p-x--sm">
          <div className="dropdown__item dropdown__item-username p-y--sm">
            {user?.username}
          </div>
          <div>
            <span
              className="p-l--xxxs p-r--xxxs"
              style={{
                display: "inline-block",
                fontSize: "0.9em",
                color: "#BBBBBB",
              }}
            >
              {`${user?.organization?.code} - ${user?.organization?.name}`}{" "}
            </span>
          </div>
          <div
            className="dropdown__item dropdown__item-account p-y--sm "
            onClick={handleClickToProfile}
          >
            {/* Account */}
            {translate("general.defaultHeader.account")}
          </div>
          {/* <div
            className="dropdown__item dropdown__item-change-password p-y--sm"
            onClick={handleClickToChangePassword}
          >
            Change password
            {translate("general.defaultHeader.changePass")}
          </div> */}
          <div
            className="dropdown__item dropdown__item-change-password p-y--sm"
            onClick={handleGetSwitchAccountCode}
          >
            {/* Switch account */}
            {translate("general.defaultHeader.switchAccount")}
          </div>
          <div
            className="dropdown__item dropdown__item-sign-out p-y--sm"
            onClick={handleLogout}
          >
            {/* Sign out */}
            {translate("general.defaultHeader.signOut")}
          </div>
        </div>
      </div>
    </div>
  );
}

export default DropdownMenu;
